/* eslint-disable */
import Vue from 'vue'
import RaiseNewPayment from './index.vue'

const PopupBox = Vue.extend(RaiseNewPayment)
let instance = null
RaiseNewPayment.install = function (data) {
  if (data.action === 'close') {
    if (instance) {
      instance.show = false
    }
    return
  }
  instance = new PopupBox({
    data
  }).$mount()
  document.body.appendChild(instance.$el)
  Vue.nextTick(() => {
    instance.show = true
    // show 和弹窗组件里的show对应，用于控制显隐
  })
}
export default RaiseNewPayment